// Pure helpers for the issue (bill) detail screen, extracted for unit testing.

export const BILL_STAGES = ['Introduced', 'Committee', 'Floor', 'Enrolled', 'Law'] as const;

export interface BillStageInput {
  status?: string | null;
  latest_action?: string | null;
  latest_location?: string | null;
}

// Map a bill's latest action/status/location onto the 5-stage citizen timeline.
// Returns the index into BILL_STAGES (0 = Introduced … 4 = Law).
export function deriveStage(b: BillStageInput): number {
  const s = `${b.status || ''} ${b.latest_action || ''} ${b.latest_location || ''}`.toLowerCase();
  // Signed-into-law phrasings vary ("Governor Signed", "Signed by Governor"),
  // so match governor+sign in either order before the generic "governor" (sent
  // to the governor) check that marks the Enrolled stage.
  if (/became law|signed into law|enacted|effective|governor.*sign|sign.*governor/.test(s)) return 4;
  if (/enrolled|sent to the governor|governor/.test(s)) return 3;
  if (/third reading|second reading|floor|passed/.test(s)) return 2;
  if (/committee|referred/.test(s)) return 1;
  return 0;
}

// Sponsor names arrive "Last, First"; show them "First Last".
export function flipName(name?: string | null): string {
  if (!name) return 'Unknown';
  const parts = name.split(',').map((p) => p.trim());
  return parts.length === 2 ? `${parts[1]} ${parts[0]}` : name;
}
